import React from 'react';
import styled from '@emotion/styled';
import type {
  BorderProps,
  BorderRadiusProps,
  DisplayProps,
  GridGapProps,
  GridTemplateColumnsProps,
  SizeProps,
  SpaceProps,
  WidthProps,
} from 'styled-system';
import {
  border,
  borderRadius,
  display,
  gridGap,
  gridTemplateColumns,
  size,
  space,
  width,
} from 'styled-system';

import ResponsiveImage from 'common/components/ResponsiveImage';
import type { BoxSizingProps } from 'common/theme/system-utilities';

interface ProductThumbnailsProps {
  images: Array<{
    thumbnail: string;
    alt: string;
  }>;
}

const THUMBNAIL_SIZE = 92;

const List = styled.ul<
  DisplayProps | GridTemplateColumnsProps | GridGapProps | SpaceProps | WidthProps
>`
  ${display};
  ${gridTemplateColumns};
  ${gridGap};
  ${space};
  ${width};
`;

const Image = styled(ResponsiveImage)<SizeProps | BorderProps | BorderRadiusProps | BoxSizingProps>`
  ${size};
  ${border}
  ${borderRadius};
`;

const ProductThumbnails = ({ images }: ProductThumbnailsProps) => (
  <List
    p="sp_0"
    pt="sp_16"
    m="sp_0"
    width={1}
    display="grid"
    gridGap="sp_16"
    gridTemplateColumns={`repeat(auto-fill, ${THUMBNAIL_SIZE}px)`}
  >
    {images.map(({ thumbnail, alt }) => (
      <Image
        key={thumbnail}
        src={thumbnail}
        alt={alt}
        border="3"
        borderRadius="small"
        size={THUMBNAIL_SIZE}
        widths={THUMBNAIL_SIZE}
      />
    ))}
  </List>
);

export default ProductThumbnails;
